import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'tisa-image',
  templateUrl: './image.component.html',
  styleUrls: ['image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImageComponent implements OnInit {
  @HostBinding('class')
  readonly className = 'h-full w-full block';

  @Input()
  loading: 'lazy' | 'auto' | 'eager' = 'auto';

  @Input()
  src: string | undefined;

  @Input()
  alt: string | undefined;

  @Input()
  height: string | undefined;

  @Input()
  width: string | undefined;

  @Input()
  mode: 'cover' | 'contain' = 'cover';

  get imgClassName(): string {
    const base = 'h-full w-full';

    if (this.mode === 'cover') {
      return `${base} object-cover`;
    }

    return `${base} object-contain`;
  }

  ngOnInit() {
    if (this.loading === 'lazy' && !this.height) {
      throw new Error(
        '[ImageComponent] You must specify height whenever using lazy loading.',
      );
    }
  }
}
